export enum NavigationArea {
    OpenSea = 'OpenSea',
    ShelteredArea = 'ShelteredArea',
    OceanicNavigation = 'OceanicNavigation',
    Cabotage = 'Cabotage',
    Coastal = 'Coastal',
}
